module.exports = __webpack_public_path__ + "img/add.9e99bec.svg";